import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const USAGE_MUTATORS = /\/(coach\/chat|reports\/analyze|reports\/analyze-file|documents\/upload|vendors)(\/|$|\?)/;
const RESTRICTED = [
  { re: /\/coach\/chat/, metric: "ai_questions" },
  { re: /\/reports\/analyze/, metric: "report_analyses" },
  { re: /\/documents\/upload/, metric: "storage" },
  { re: /\/vendors(\/|$|\?)/, metric: "vendors" },
];
const metricFor = (url = "") => (RESTRICTED.find((r) => r.re.test(url)) || {}).metric || "";

api.interceptors.response.use(
  (res) => {
    const url = res.config?.url || "";
    const method = (res.config?.method || "").toLowerCase();
    if (["post", "put", "delete"].includes(method) && USAGE_MUTATORS.test(url)) {
      window.dispatchEvent(new CustomEvent("cc:usage-changed"));
    }
    return res;
  },
  (error) => {
    if (error.response?.status === 402) {
      window.dispatchEvent(new CustomEvent("cc:limit-reached", {
        detail: { metric: metricFor(error.config?.url), detail: error.response?.data?.detail },
      }));
    }
    return Promise.reject(error);
  }
);

export const logConversion = (type, extra = {}) =>
  api.post("/conversion/event", { type, ...extra }).catch(() => {});

export const getToken = () => localStorage.getItem("cc_token");

export function apiErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export { API };
